import { Component, inject, Input } from '@angular/core';

import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { DialogService } from 'primeng/dynamicdialog';

import { Hub } from '@qwyk/models';

import {
    MagayaNetworkConfigurationEntity,
    CreateMagayaNetworkConfigurationPayload,
} from '../../+state/magaya-network-configuration.models';
import { MagayaNetworkConfigurationFacade } from '../../+state/magaya-network-configuration.facade';
import { MagayaNetworkUpdateComponent } from '../magaya-network-update/magaya-network-update.component';

@Component({
    selector: 'qwyk-magaya-network-view',
    templateUrl: './magaya-network-view.component.html',
    styleUrls: ['./magaya-network-view.component.scss'],
    providers: [DialogService]
})
export class MagayaNetworkViewComponent{

    private modal = inject(DialogService);
    private magayaNetworkConfiguration = inject(MagayaNetworkConfigurationFacade);

    public magayaNetworkConfiguration$ =
        this.magayaNetworkConfiguration.magayaNetworkConfiguration$;
    public loading$ = this.magayaNetworkConfiguration.loading$;
    public error$ = this.magayaNetworkConfiguration.error$;
    public initialized$ = this.magayaNetworkConfiguration.initialized$;
    public edit = false;

    public vm$ = combineLatest([
        this.initialized$,
        this.loading$,
        this.error$,
        this.magayaNetworkConfiguration$,
    ]).pipe(
        map(([initialized, loading, error, magayaNetworkConfiguration]) => ({
            initialized,
            loading,
            error,
            magayaNetworkConfiguration,
        }))
    );

    private _organization: Hub.Organization;

    get organization(): Hub.Organization {
        return this._organization;
    }

    @Input()
    set organization(value: Hub.Organization) {
        this._organization = value;
        this.magayaNetworkConfiguration.init(value);
    }

    public onCreateMagayaNetworkConfiguration(
        e: CreateMagayaNetworkConfigurationPayload
    ): void {
        this.magayaNetworkConfiguration.create(e);
    }

    public onTestNetworkConfiguration(e: Hub.Organization): void {
        this.magayaNetworkConfiguration.test(e);
    }

    public onEdit(
        magayaNetworkConfiguration: MagayaNetworkConfigurationEntity
    ): void {
        const modalRef = this.modal.open(MagayaNetworkUpdateComponent, {
            position: 'center',
            showHeader: false,
            closable: true,
            width: 'auto',
            contentStyle: {
                'padding': 0
            }
        });

        const dialogRef = this.modal.dialogComponentRefMap.get(modalRef);
        dialogRef.changeDetectorRef.detectChanges();
        const instance = dialogRef.instance.componentRef.instance as MagayaNetworkUpdateComponent;
        instance.init(magayaNetworkConfiguration);
    }
}
